(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eufy-full-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('eufy-navigation'))customElements.define('eufy-navigation',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;this.dialog=this.querySelector('dialog');
  document.addEventListener('click',event=>{const trigger=event.target.closest('[data-eufy-menu-open]');if(!trigger)return;event.preventDefault();this.trigger=trigger;this.dialog.showModal();document.documentElement.classList.add('eufy-menu-lock');trigger.setAttribute('aria-expanded','true');this.querySelector('[data-eufy-menu-close]').focus();},{signal});
  this.querySelector('[data-eufy-menu-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('eufy-menu-lock');this.trigger?.setAttribute('aria-expanded','false');this.trigger?.focus();},{signal});
 }
 disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close();document.documentElement.classList.remove('eufy-menu-lock');}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eufy-starfield"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eufy-starfield')) {
  class EufyStarfield extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d', { alpha: true });
      if (!this.context) return;
      this.button = this.querySelector('button');
      this.controller = new AbortController();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = Math.max(1, Math.min(3, Number(this.dataset.speed) || 2));
      this.density = Math.max(1, Math.min(3, Number(this.dataset.density) || 2));
      this.boost = 0;
      this.velocity = 1;
      this.clock = 0;
      this.frame = 0;
      this.paused = false;
      try { this.paused = localStorage.getItem('eufy-stars-paused') === 'true'; } catch {}
      this.tick = this.tick.bind(this);
      const signal = this.controller.signal;
      window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
      window.addEventListener('resize', () => this.resize(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
      this.motion.addEventListener('change', () => this.syncMotion(), { signal });
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        try { localStorage.setItem('eufy-stars-paused', String(this.paused)); } catch {}
        this.syncMotion();
      }, { signal });
      this.resize();
      this.syncMotion();
    }

    resize() {
      const bounds = this.canvas.getBoundingClientRect();
      this.width = Math.max(1, Math.round(bounds.width));
      this.height = Math.max(1, Math.round(bounds.height));
      const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      this.canvas.width = Math.round(this.width * ratio);
      this.canvas.height = Math.round(this.height * ratio);
      this.context.setTransform(ratio, 0, 0, ratio, 0, 0);
      const mobile = this.width < 768;
      const count = Math.min(mobile ? 78 : 155, Math.max(30, Math.round(this.width * this.height / 14000 * (.6 + this.density * .2))));
      this.stars = Array.from({ length: count }, () => {
        const depth = Math.random();
        return {
          x: Math.random() * this.width,
          y: Math.random() * this.height,
          depth,
          radius: .45 + depth * 1.05,
          alpha: .23 + depth * .53,
          phase: Math.random() * Math.PI * 2,
          blue: Math.random() > .82
        };
      });
      this.draw(0);
    }

    onScroll() {
      const now = performance.now();
      const y = Math.max(0, window.scrollY);
      const elapsed = Math.max(16, now - this.lastScrollTime);
      const change = Math.abs(y - this.lastScrollY);
      this.lastScrollY = y;
      this.lastScrollTime = now;
      if (this.paused || this.motion.matches || document.hidden) return;
      const impulse = Math.min(6, change / elapsed * 1.8);
      this.boost = Math.max(this.boost, impulse);
    }

    syncMotion() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = 0;
      this.lastScrollY = Math.max(0, window.scrollY);
      this.lastScrollTime = performance.now();
      this.boost = 0;
      this.velocity = 1;
      this.button.hidden = this.motion.matches;
      this.button.setAttribute('aria-pressed', String(this.paused));
      const label = this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      this.button.setAttribute('aria-label', label);
      this.button.title = label;
      if (!this.paused && !this.motion.matches && !document.hidden) {
        this.frame = requestAnimationFrame(this.tick);
      }
    }

    tick(now) {
      if (!this.isConnected || this.paused || this.motion.matches || document.hidden) {
        this.frame = 0;
        return;
      }
      const dt = this.lastTime ? Math.min((now - this.lastTime) / 1000, .05) : 0;
      this.lastTime = now;
      this.clock += dt;
      this.velocity += (1 + this.boost - this.velocity) * (1 - Math.exp(-dt * 5));
      this.boost *= Math.exp(-dt * 1.65);
      this.draw(dt);
      this.frame = requestAnimationFrame(this.tick);
    }

    draw(dt) {
      const ctx = this.context;
      ctx.clearRect(0, 0, this.width, this.height);
      for (const star of this.stars) {
        const pace = (3 + star.depth * 10) * (.45 + this.speed * .275) * this.velocity;
        const dx = pace * .22 * dt;
        const dy = -pace * dt;
        star.x = (star.x + dx + this.width + 12) % (this.width + 12);
        star.y += dy;
        if (star.y < -10) { star.y = this.height + 8; star.x = Math.random() * this.width; }
        const opacity = star.alpha * (.87 + .13 * Math.sin(this.clock * .7 + star.phase));
        const color = star.blue ? '165,220,255' : '231,240,255';
        if (star.depth > .7) {
          ctx.fillStyle = `rgba(${color},${opacity * .08})`;
          ctx.beginPath();
          ctx.arc(star.x, star.y, star.radius * 3.2, 0, Math.PI * 2);
          ctx.fill();
        }
        if (this.velocity > 2) {
          const trail = Math.min(11, (this.velocity - 2) * star.depth * 2);
          ctx.strokeStyle = `rgba(${color},${opacity * .2})`;
          ctx.lineWidth = star.radius * .8;
          ctx.beginPath();
          ctx.moveTo(star.x - trail * .22, star.y + trail);
          ctx.lineTo(star.x, star.y);
          ctx.stroke();
        }
        ctx.fillStyle = `rgba(${color},${opacity})`;
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('eufy-starfield', EufyStarfield);
}
  } catch(e) { console.error(e); }
})();

})();
